import{styled as i}from"@mui/material/styles";const m=i("img")((({theme:i})=>({display:"block",maxWidth:"100%",borderRadius:i.spacing(6)})));export{m as Image};
//# sourceMappingURL=styles.js.map
